module.exports = __webpack_public_path__ + "static/media/historia-dla-dzieci.a493973f.png";